module.exports = __webpack_public_path__ + "static/img/power-pole-mk-2_256.7df454a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/power-pole-mk-2_256.png
// module id = lhfu
// module chunks = 0